/**
 * created by mleitzell on 12/20/17.
 */
import BasicGrid from "app/widgets/DFGrid/BasicGrid";
import dateConvert from "common/helper/dateConvert";
import stringUtil from "common/helper/stringUtil";
import userAgentUtil from "common/helper/userAgentUtil";

const ConcurrentLoginGrid = BasicGrid.extend({

    options: {
        name: "ConcurrentLoginGrid"
    },

    init: function(element, options) {
        var opts = $.extend({}, options, {
            filterable: false,
            sortable: false,
            columns: [{
                field: "userAgent",
                localizedTitle: "userAgent",
                template: this._userAgentTemplate
            }, {
                field: "clientKey",
                localizedTitle: "clientKey"
            }, {
                field: "lastAccess",
                localizedTitle: "lastAccess.time",
                template: this._lastAccessTemplate
            }]
        });

        BasicGrid.fn.init.call(this, element, opts);
    },

    _userAgentTemplate: function(model) {
        return stringUtil.escapeHtml(userAgentUtil.formatUserAgent(model.userAgent));
    },

    _lastAccessTemplate: function(model) {
        return stringUtil.escapeHtml(kendo.toString(dateConvert.toDateUsingClientsTimeZone(model.lastAccess), "g"));
    }
});

kendo.ui.plugin(ConcurrentLoginGrid);
export default ConcurrentLoginGrid;
